/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */



// product page
$(document).ready(function() {
  
  $(document).on('click', '.sls-option-container', function() {
    setTimeout(function(){
      var priceHtml = $('product-meta .product-meta__price-list-container').html();
      $('.mobile_content .product-meta__price-list-container').html(priceHtml)
    },1000);
    
    
    setTimeout(function() {
      if($('.sls-option-container input').is(':checked')){
        var changeValue = $(".sls-option-container input.sls-option:checked").val();
        // console.log(changeValue);
      }
      if(changeValue == "one_time"){
        $(".itg_product_richtext_prdct").hide();
        $(".itg_product-form__text").show();
        $(".itg_payment-methods").removeClass("subscribe_hide");
      } else {
        $(".itg_product_richtext_prdct").show();
        $(".itg_product-form__text").hide();
        $(".itg_payment-methods").addClass("subscribe_hide");
      }
    },1000);
  });


 setTimeout(function(){
   if($('.sls-option-container input').is(':checked')){
      var changeValue = $(".sls-option-container input.sls-option:checked").val();
      // console.log(changeValue);
    }
    
   if(changeValue == "one_time"){
      $(".itg_product-form__text").show();
      $(".itg_product_richtext_prdct").hide();
    } else {
      $(".itg_product_richtext_prdct").show();
      $(".itg_product-form__text").hide();
    }
}, 1000); 
  
  var ratingHTML = $('reviewsio-product-ratings').html();
  $('.product_mobile_review').html(ratingHTML);
  
  $(".product_mobile_review").click(function() {
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#ReviewsWidget").offset().top
    }, 1000);
});
});
// end product page


// itg js

$(document).ready(function(){
  let languages = $('.ly-breakpoint-2 .ly-languages-switcher span.ly-custom-dropdown-current-inner-text').text();
  languages = languages.trim();
  console.log(languages);
  let curr = $('.ly-breakpoint-2 .ly-currency-switcher span.ly-custom-dropdown-current-inner-text span.ly-iso-code').text();
  console.log(curr);
  setTimeout(function(){
    $('.itg_product-form__text ul li:first-child').addClass('ship_text');
    $('.itg_product-form__text ul li:nth-child(2)').addClass("delivered_text");
  }, 2000);

  setTimeout(function(){  
  var oneTimeValue = $(".sls-option-container input.sls-option:checked").val();
    console.log(oneTimeValue);
    if(oneTimeValue == 'one_time'){
          
        if(curr == 'EUR' && languages == 'English'){        
          $('.itg_product-form__text ul li.ship_text h5').text('Free shipping: NL €25+, BE/DE €50+, EU/GB €75+');
          $('.itg_product-form__text ul li.delivered_text h5').text('Fast Delivery: 1-3 business days');
        }else if(curr == 'USD' && languages == 'English'){
          $('.itg_product-form__text ul li.ship_text h5').text('Free Shipping: USA $150+, Worldwide $275+');
          $('.itg_product-form__text ul li.delivered_text h5').text('Fast Delivery: USA 3-4 business days');
        }else if(curr == 'GBP' && languages == 'English'){
          $('.itg_product-form__text ul li.ship_text h5').text('Free shipping to United Kingdom from £85');
          $('.itg_product-form__text ul li.delivered_text h5').text('Fast Delivery: 2-3 business days');
        }else if(curr == 'SEK' && languages == 'English'){
          $('.itg_product-form__text ul li.ship_text h5').text('Free shipping to Sweden from SEK 780');
          $('.itg_product-form__text ul li.delivered_text h5').text('Fast Delivery: 2-3 business days');
        }else if(curr == 'DKK' && languages == 'English'){
          $('.itg_product-form__text ul li.ship_text h5').text('Free shipping to Denmark from DKK 745');
          $('.itg_product-form__text ul li.delivered_text h5').text('Fast Delivery: 2-3 business days');
        }else if(curr == 'CHF' && languages == 'English'){
          $('.itg_product-form__text ul li.ship_text h5').text('Free shipping to Switzerland from CHF 135');
          $('.itg_product-form__text ul li.delivered_text h5').text('Fast Delivery: 2-3 business days');
        }else if(curr == 'EUR' && languages == 'Deutsch'){           
          $('.itg_product-form__text ul li.ship_text h5').text('Kostenloser Versand: DE €50+, AT €75+, CH €125+');
        }else if(curr == 'CHF' && languages == 'Deutsch'){         
          $('.itg_product-form__text ul li.ship_text h5').text('Kostenloser Versand in die Schweiz ab 135 CHF');
        }
    }
  }, 2000);
      
    $(document).on('click', '.sls-option-container', function() {
      setTimeout(function() {
        if($('.sls-option-container input').is(':checked')){
            var subValue = $(".sls-option-container input.sls-option:checked").val();
            if(subValue == 0 || subValue == '0'){
               setTimeout(function(){
                if(curr == 'EUR' && languages == 'English'){
                    $('.itg_product_richtext_prdct ul li:last-child h5').text('Free shipping: NL €25+, BE/DE €50+, EU/UK €75+');
                  }else if(curr == 'GBP' && languages == 'English'){
                    $('.itg_product_richtext_prdct ul li:last-child h5').text('Free shipping to United Kingdom from £85');
                  }else if(curr == 'SEK' && languages == 'English'){
                    $('.itg_product_richtext_prdct ul li:last-child h5').text('Free shipping to Sweden from SEK 780');
                  }else if(curr == 'DKK' && languages == 'English'){
                    $('.itg_product_richtext_prdct ul li:last-child h5').text('Free shipping to Denmark from DKK 745');
                  }else if(curr == 'CHF' && languages == 'English'){
                    $('.itg_product_richtext_prdct ul li:last-child h5').text('Free shipping to Switzerland from CHF 135');
                  }else if(curr == 'USD' && languages == 'English'){
                    $('.itg_product_richtext_prdct ul li:last-child h5').text('Free Shipping: USA $150+, Worldwide $275+');
                  }else if(curr == 'CHF' && languages == 'Deutsch'){
                     $('.itg_product_richtext_prdct ul li:last-child h5').text('Kostenloser Versand in die Schweiz ab 135 CHF');
                  }
                }, 100);
            }
        }
      }, 1000);
    });
   
})

//  window.onload = function() {
//      var button = document.getElementById('currency_btn');
//      var currencyVal = button.getAttribute('data-currencysymbol');
//     let contentElement = document.getElementById("tab_content");
//     let content = contentElement.innerHTML;
//     let formContent = document.querySelector('.product-form__text.itg_text');
//     let formContentEle = formContent.innerHTML;
//     if(currencyVal === 'CHF'){
//         if (content.includes('kr') || content.includes('€') || content.includes('£') || content.includes('$')) {
//             content = content.replaceAll('kr', 'CHF')
//                              .replaceAll('€', 'CHF')
//                              .replaceAll('£', 'CHF')
//                              .replaceAll('$', 'CHF');
//             contentElement.innerHTML = content;
//         }
//     }else if(currencyVal === 'kr.'){
//       if (content.includes('CHF') || content.includes('€') || content.includes('£') || content.includes('$')) {
//             content = content.replaceAll('CHF', 'DKK')
//                              .replaceAll('€', 'DKK')
//                              .replaceAll('£', 'DKK')
//                              .replaceAll('$', 'DKK');
//             contentElement.innerHTML = content;
//     }
//   }else if(currencyVal === '€'){
//       if (content.includes('CHF') || content.includes('DKK') || content.includes('£') || content.includes('$')) {
//             content = content.replaceAll('CHF', '€')
//                              .replaceAll('DKK', '€')
//                              .replaceAll('£', '€')
//                              .replaceAll('$', '€');
//             contentElement.innerHTML = content;
//     }
//   }
//    else if(currencyVal === '£'){
//       if (content.includes('CHF') || content.includes('DKK') || content.includes('€') || content.includes('SEK') || content.includes('$')) {
//             content = content.replaceAll('CHF', '£')
//                              .replaceAll('DKK', '£')
//                              .replaceAll('SEK', '£')
//                              .replaceAll('€', '£')
//                              .replaceAll('$', '£');
//             contentElement.innerHTML = content;
//     }
//   }
//     else if(currencyVal === '$'){
//       if (content.includes('CHF') || content.includes('DKK') || content.includes('€') || content.includes('SEK') || content.includes('£')) {
//             content = content.replaceAll('CHF', '$')
//                              .replaceAll('DKK', '$')
//                              .replaceAll('€', '$')
//                              .replaceAll('SEK', '$')
//                              .replaceAll('£', '$');
//             contentElement.innerHTML = content;
//     }
//   }
//     else if(currencyVal === 'kr'){
//       if (content.includes('CHF') || content.includes('DKK') || content.includes('€') || content.includes('$') || content.includes('£')) {
//             content = content.replaceAll('CHF', 'SEK')
//                              .replaceAll('DKK', 'SEK')
//                              .replaceAll('€', 'SEK')
//                              .replaceAll('$', 'SEK')
//                              .replaceAll('£', 'SEK');
//             contentElement.innerHTML = content;
//     }
//   }
// }






